<!-- 
Shows action buttons and tabs for the user page.
-->
<template>
  <div>
    <our-actions-bar
      :actions="actions"
      @edit="showEditDialog=true" 
      @enableMfa="showEnableMfaDialog=true"
      @disableMfa="showDisableMfaDialog=true"
      @switchToEmailMfa="showSwitchToEmailMfaDialog=true"
      @impersonate="impersonateUser"
    />
    <v-card class="home">
      <v-tabs slider-color="primary" show-arrows>
        <v-tab :to="getUrl('summary')">
          Summary
        </v-tab>
        <v-tab :to="getUrl('activity')">
          Activity
        </v-tab>
      </v-tabs>
      <slot/>
    </v-card>
    <prisms-user-edit-dialog v-model="showEditDialog" :user-id="userId" :create="false" />
    <prisms-user-disable-mfa-dialog v-model="showDisableMfaDialog" :user-id="user.userId" @save="reload"/>
    <prisms-user-switch-to-email-mfa-dialog v-model="showSwitchToEmailMfaDialog" :user-id="user.userId" @save="reload" />

    <our-confirmation-dialog v-model="showEnableMfaDialog" title="Enable multi-factor authentication" @confirm="enableMfa">
      <p>Are you sure you want to enable the user's Multi-Factor Authentication?</p>
    </our-confirmation-dialog>
  </div>
</template>

<script>
import PrismsUserEditDialog from "@/components/prisms-users/PrismsUserEditDialog.vue";
import PrismsUserDisableMfaDialog from "@/components/prisms-users/PrismsUserDisableMfaDialog.vue";
import PrismsUserSwitchToEmailMfaDialog from "@/components/prisms-users/PrismsUserSwitchToEmailMfaDialog.vue";
import { SIGN_OUT } from "@/store/users/action-types";
import { SIGN_IN_SET_DATA } from "@/store/users/mutation-types";
import * as action from "@/store/prisms-users/action-types";
import * as claim from "@/store/claim-types";

export default {
  components: { PrismsUserEditDialog, PrismsUserDisableMfaDialog, PrismsUserSwitchToEmailMfaDialog },
  props: {
    userId: {
      required: true,
      type: Number
    }    
  },
  data() {
    return {
      showEditDialog: false,
      showEnableMfaDialog: false,
      showDisableMfaDialog: false,
      showSwitchToEmailMfaDialog: false,
      signingOut: false,
    };
  },
  computed: {
    actions() {
      var results = [];
      if(this.testingToolsEnabled){

        results.push(
          { icon: "edit", text: "Edit", description: "Edit this user's details.", emit: "edit" },
            {
              icon: "person",
              text: "Impersonate",
              description: "Impersonate this user for testing purposes.",
              emit: "impersonate"
            }
        );
      }
      if(this.canSwitchToEmailMultiFactorAuth){
            results.push(
              { icon: "email", text: "Switch to email multi-factor", description: "Remove authenticator and switch to email multi-factor authentication", emit: "switchToEmailMfa" },
            );
        }
        if(this.canEnableMultiFactorAuth){
            results.push(
              { icon: "done", text: "Enable Multi-Factor", description: "Enable multi-factor authentication", emit: "enableMfa" },
            );
        }
        if(this.canDisableMultiFactorAuth){
            results.push(
              { icon: "block", text: "Disable Multi-Factor", description: "Disable multi-factor authentication", emit: "disableMfa" },
            );
        }
      return results;
    },
    user() {
      return this.state.data;
    },
    state() {
      return this.$store.state.prismsUsers.view;
    },
    testingToolsEnabled() {
      return this.$store.getters.testingToolsEnabled;
    },
    hasUserEditPermission() {
      return this.$store.getters.claims.includes(claim.USERS_EDIT);
    },
    canSwitchToEmailMultiFactorAuth() {
      return this.hasUserEditPermission && this.user.canSwitchToEmailMultiFactorAuth;
    },
    canEnableMultiFactorAuth() {
      return this.hasUserEditPermission && this.user.canEnableMultiFactorAuth;
    },
    canDisableMultiFactorAuth() {
      return this.hasUserEditPermission && this.user.canDisableMultiFactorAuth;
    }
  },
  watch: {
    userId() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.dispatch(action.VIEW_REFRESH, this.userId);
    },
    reload() {
      this.$store.dispatch(action.VIEW, this.userId);
    },
    getUrl(suffix) {
      return `/users/${this.userId}/${suffix}`;
    },
    async impersonateUser() {
      this.signingOut = true;
      this.$store.commit(SIGN_IN_SET_DATA, { email: this.user.emailAddress, password: "password" });
      if (this.$store.getters.isSignedIn) {
        await this.$store.dispatch(SIGN_OUT);
      }
      this.$router.push("/sign-in");
    },
    async enableMfa() {
      if (await this.$store.dispatch(action.ENABLE_MFA, this.user.userId)) {
        this.showEnableMfaDialog = false;
        this.reload();
      } else {
        this.showValidationDialog = true;
      }   
    }
  }
};
</script>
